// External
import React, { Component } from 'react';
import { withOktaAuth } from '@okta/okta-react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import { withRouter } from 'react-router-dom';
import DocumentTitle from 'react-document-title';
import { withLastLocation } from 'react-router-last-location';
import { VelocityTransitionGroup } from 'velocity-react';

// Internal
import { navRoutes } from './router/routes';
import SlideMenuContainer from '../navigation/SlideMenuContainer';
import OfflineBanner from '../offline/offline';
import { DownloadBanner } from '../downloads';
import { Spinner } from '../components/';
import Toast from '~COMPONENTS/toast/Toast';
import Modal from '~COMPONENTS/modal/Modal';
import Timer from '~COMPONENTS/timer/Timer';

import { currentCartCrd } from '../account/reducer';
import { requestCurrentCartCrd, setUseCurrentContract } from '../account/actions';
import { initializeUserAuth } from '../auth/actions';
import { isLoggedIn, hasLoginStarted, hasAuthCheckStarted } from '../auth/reducer';
import { setOrderDetails } from '../checkout/actions';
import { isReturnStep } from '../orders/orderReturns/reducer';
import { closeNavMenu } from '../navigation/actions';
import { requestMinRules, selectShopDepartment } from '../shop/actions';
import {
  getAccountDetails,
  getAccountDepartments,
  storeUserData,
  setAlwaysShowCart,
  setDeepLinkInfoLoading,
  setUserAccount
} from '../user/actions';
import { fetchGamedayAccount as gamedayAccountRequest } from '../gamedayAccount/actions';
import { getCurrentAllotments, getFutureAllotments } from '../gamedayAccount/selectors';
import { getFundamentalData } from '../fundamentals/actions';
import { getUserAccount, getUserData, getAllAccountsLoadedInfo, accountDetails } from '../user/selectors';
import { getCart } from '../carts/actions';
import { isStaticPage } from '../static/reducer';
import { visible } from '../components/modal/reducer';

import { DEFAULT_ONPOPSTATE, rootPropTypes } from './constants';

import { importLocalStorageData } from '../user/helpers';
import { ORDER_TYPE_ATONCE, ORDER_TYPE_FUTURES } from '../shop/constants';
import { getSelectedDepartment, isAdminCart } from '../shop/selectors';
import { ZERO_DOLLAR_VALUE } from '../util/constants';
import { mapAllotmentDepts } from '../util/mapAllotmentDepts';

import { hideDefaultTopNavigation } from '../navigation/reducer';
import { requestAllAddresses } from '../addressBook/actions';
import '../styles/critical/_index.styl';
import '../styles/nonCritical/_index.styl';
import '@nike/eds/dist/index.css';

import {
  sendEventToGA,
  GA_EVENT_INITIALIZE_USER,
  GA_EVENT_CHANGE_ACCOUNT,
  GA_EVENT_PAGE_VIEW
} from '../analytics/constants';

// Constants
const navLinks = navRoutes.map(r => ({
  to: r.path,
  label: r.title,
  section: r.section,
  routes: r.routes,
  hideLink: r.hideLink
}));

const normalizeDept = (dept, type) => ({
  ...dept,
  name: dept.departmentName,
  number: dept.departmentNumber,
  code: dept.currencyCode,
  currentRemaining: type === ORDER_TYPE_ATONCE ? dept.remainingAllotment : ZERO_DOLLAR_VALUE,
  futureRemaining: type === ORDER_TYPE_FUTURES ? dept.remainingAllotment : ZERO_DOLLAR_VALUE,
  currentBillable: type === ORDER_TYPE_ATONCE && dept.billable,
  futureBillable: type === ORDER_TYPE_FUTURES && dept.billable,
  type,
  poPrefix: dept.poPrefix
});

// TODO: Refactor ALL of this
export class Root extends Component {
  // eslint-disable-next-line react/state-in-constructor
  state = {
    accountDetailsCalled: false,
    deepLink: null,
    isInitialized: false,
    hasSentInitializeUserEvent: false
  };

  componentDidMount() {
    const { selectShopDepartment, setUserAccount, storeUserData, userData } = this.props;
    const { hasSentInitializeUserEvent } = this.state;

    sessionStorage.previousPath = undefined;
    window.onpopstate = DEFAULT_ONPOPSTATE;
    importLocalStorageData(storeUserData, setUserAccount, selectShopDepartment);

    // make sure GA_EVENT_INITIALIZE_USER is only called once (both when logging in, and refreshing)
    if (userData?.role && userData?.country && !hasSentInitializeUserEvent) {
      sendEventToGA(GA_EVENT_INITIALIZE_USER, { role: userData.role, country: userData.country });
      this.setState({ hasSentInitializeUserEvent: true });
    }
  }

  componentDidUpdate(prevProps) {
    const {
      userData,
      account,
      accountsLoaded,
      currentAllotments,
      futureAllotments,
      getAccountDetails,
      getAccountDepartments,
      requestCurrentCartCrd,
      getFundamentalData,
      fetchGamedayAccount,
      hasLoginStarted,
      initializeUserAuth,
      isAdminCart,
      isLoggedIn,
      location,
      lastLocation,
      selectedDepartment,
      // TEMPORARY REMOVAL, DO NOT DELETE
      // selectShopDepartment,
      // setAlwaysShowCart,
      requestAllAddresses,
      requestMinRules,
      setDeepLinkInfoLoading,
      setOrderDetails,
      setUserAccount,
      currentCartCrd,
      setUseCurrentContract,
      accountDetails,
      oktaAuth,
      authState,
      hasAuthCheckStarted
    } = this.props;
    const { accountDetailsCalled, deepLink, isInitialized } = this.state;
    const sessionStorageDeepLink = sessionStorage.getItem('deepLink');
    if (window && !window.dtmData) {
      window.dtmData = {};
    }

    if (currentAllotments && futureAllotments) {
      if (
        // Allotments loaded for the first time
        !prevProps.currentAllotments ||
        !prevProps.futureAllotments ||
        // User switched accounts
        prevProps.currentAllotments !== currentAllotments
      ) {
        const currentAllotmentDepts = mapAllotmentDepts(currentAllotments.departments);
        const futureAllotmentDepts = mapAllotmentDepts(futureAllotments.departments);

        if (currentAllotmentDepts.length === 1) {
          const hasAtOnce =
            !!currentAllotmentDepts.length && parseInt(currentAllotmentDepts[0].remainingAllotment, 10) > 0;
          const hasFutures =
            !!futureAllotmentDepts.length && parseInt(futureAllotmentDepts[0].remainingAllotment, 10) > 0;

          if ((hasAtOnce || hasFutures) && !(hasAtOnce && hasFutures)) {
            /*
            // TEMPORARY REMOVAL, DO NOT DELETE
            setAlwaysShowCart(true);
            selectShopDepartment(
              hasAtOnce || !hasFutures
                ? normalizeDept(currentAllotments.departments[0], ORDER_TYPE_ATONCE)
                : normalizeDept(futureAllotments.departments[0], ORDER_TYPE_FUTURES)
            );
            */
          }
        }
      }
    }

    if (!isLoggedIn && !hasLoginStarted && !deepLink) {
      if (authState) {
        const { isAuthenticated } = authState;
        if (isAuthenticated && !hasAuthCheckStarted) {
          // hasAuthCheckStarted ensures user is initialized once only
          initializeUserAuth(oktaAuth);
        }
      }

      if (!prevProps.lastLocation && lastLocation) {
        if (!sessionStorageDeepLink && lastLocation.pathname !== '/') {
          setDeepLinkInfoLoading(true);
          sessionStorage.setItem('deepLink', lastLocation.pathname);
        } else if (sessionStorageDeepLink === '/') {
          sessionStorage.removeItem('deepLink');
        }
      }
    }

    if (deepLink && sessionStorageDeepLink && window.location.pathname !== sessionStorageDeepLink) {
      setDeepLinkInfoLoading(false);
      this.removeDeepLink();
    }

    if (!prevProps.accountsLoaded && accountsLoaded && userData?.accountDepartments?.length === 1) {
      const { accountId: number, accountName: name, id } = userData.accountDepartments[0];
      const newAccount = { id, number, name };
      setUserAccount(newAccount);
      localStorage.setItem('userData', JSON.stringify(newAccount));
    }

    if (isInitialized && selectedDepartment && account && !isAdminCart) {
      if (
        (!prevProps.selectedDepartment && selectedDepartment) ||
        (prevProps.selectedDepartment &&
          (selectedDepartment.number !== prevProps.selectedDepartment.number ||
            selectedDepartment.type !== prevProps.selectedDepartment.type)) || // User switched departments
        (prevProps.account && account.number !== prevProps.account.number) // User switched accounts
      ) {
        this.initializeCart();
      }
    }

    if (!prevProps.accountsLoaded && accountsLoaded && sessionStorageDeepLink) {
      this.initializeUser();
    }

    if (accountsLoaded && account && account.number) {
      // If not already called or user has switched accounts
      const accountNumber = account.number;
      if (!accountDetailsCalled || accountNumber !== prevProps.account.number) {
        this.setAccountDetailsCalled(true);

        getFundamentalData(accountNumber);
        requestMinRules();

        Promise.all([
          getAccountDetails({ accountNumber }),
          getAccountDepartments({ accountNumber }),
          requestCurrentCartCrd({ accountNumber }),
          fetchGamedayAccount({ accountNumber }).then(event => {
            if (event.type === gamedayAccountRequest.event.success) {
              requestAllAddresses();
            }

            return event;
          })
        ]).then(() => {
          this.setState({ isInitialized: true });

          if (selectedDepartment) {
            this.initializeCart();
          }
        });
      }

      if (
        accountDetails &&
        accountDetails.customerName &&
        accountDetails.region &&
        accountDetails !== prevProps.accountDetails
      ) {
        sendEventToGA(GA_EVENT_CHANGE_ACCOUNT, {
          account: accountDetails.customerName,
          geo: accountDetails.region
        });
      }
    }

    if (!isAdminCart && prevProps.isAdminCart) {
      // Admin came out of Open Cart view
      setOrderDetails(null);
    }

    if (
      currentCartCrd &&
      currentCartCrd !== prevProps.currentCartCrd &&
      currentAllotments &&
      currentAllotments.contractStartDate
    ) {
      const currentStartDate = Date.parse(currentAllotments.contractStartDate);
      const currentEndDate = Date.parse(currentAllotments.contractEndDate);
      const currentCrd = Date.parse(currentCartCrd);

      setUseCurrentContract(currentCrd <= currentEndDate && currentCrd >= currentStartDate);
    }

    // send page view events when route changes
    if (authState?.isAuthenticated && location !== prevProps.location) {
      // condition prevents a welcome_to_gameday_page_view in select account page
      if (location.pathname !== '/' || account) {
        sendEventToGA(GA_EVENT_PAGE_VIEW, {
          pathname: location.pathname
        });
      }
    }
  }

  setDeepLink = deepLink => this.setState({ deepLink });

  setAccountDetailsCalled = bool => this.setState({ accountDetailsCalled: bool });

  initializeUser = () => {
    const { userData, history, setDeepLinkInfoLoading, setUserAccount } = this.props;
    const deepLink = sessionStorage.getItem('deepLink');

    if (deepLink) {
      setDeepLinkInfoLoading(true);
      this.setDeepLink(deepLink);
      // Split out the incoming URL so we can select proper account and department
      const splitLink = deepLink.split('/');

      // [0] is an empty string
      // Looking for a gridwall or PDP link
      if (splitLink[1] === 'shop') {
        // Example URL: /shop/345608/dept/346682/atonce/468942-697
        const [, , accountId, , deptId, orderType] = splitLink;
        const currAccount = userData && userData.accountDepartments.filter(acct => acct.accountId === accountId)[0];

        if (currAccount) {
          setUserAccount({ id: currAccount.id, number: currAccount.accountId, name: currAccount.accountName });
          // TODO: Fix this. It's a race condition against all of the departments loading
          setTimeout(() => {
            this.initializeDepartments(orderType, deptId, deepLink);
            setDeepLinkInfoLoading(false);
          }, 1000);
        } else {
          this.removeDeepLink();
          setDeepLinkInfoLoading(false);
        }
      }
      // Looking for an order details id
      else if (splitLink[1] === 'orders' && splitLink[2] === 'id') {
        history.push(deepLink);
        setDeepLinkInfoLoading(false);
      } else {
        setDeepLinkInfoLoading(false);
      }

      this.setState({ isInitialized: true });
    }
  };

  initializeDepartments = (orderType, deptId, deepLink) => {
    const { currentAllotments, futureAllotments, history, selectShopDepartment } = this.props;
    const allotments = orderType === ORDER_TYPE_ATONCE ? currentAllotments : futureAllotments;
    const currDept =
      allotments &&
      allotments.departments &&
      mapAllotmentDepts(allotments.departments).find(dept => dept.departmentNumber === deptId);

    selectShopDepartment(null);

    if (currDept) {
      selectShopDepartment(normalizeDept(currDept, orderType));

      history.push(deepLink);
      this.removeDeepLink();
    }
  };

  initializeCart = () => {
    const { getCart } = this.props;
    getCart();
  };

  removeDeepLink = () => {
    setDeepLinkInfoLoading(false);
    this.setDeepLink(null);
    sessionStorage.removeItem('deepLink');
  };

  render() {
    const {
      closeNavMenu,
      children,
      isAdminCart,
      location,
      modalIsVisible,
      account,
      userData,
      isReturnStep,
      isStaticPage,
      hideDefaultTopNavigation,
      authState,
      accountsLoaded
    } = this.props;
    const { deepLink, isInitialized } = this.state;

    if (
      authState?.isAuthenticated &&
      !account &&
      userData?.accountDepartments?.length > 1 &&
      !(location.pathname === '/select-accounts' || location.pathname.indexOf('/profile') > -1) &&
      !deepLink
    ) {
      return <Redirect to={{ pathname: '/select-accounts' }} />;
    }

    const body = () =>
      authState?.isAuthenticated && (account || deepLink) ? (
        <SlideMenuContainer
          title={import.meta.env.VITE_APP_NAME}
          description={import.meta.env.VITE_APP_FULLNAME}
          navLinks={navLinks}
          onClose={closeNavMenu}
        >
          <VelocityTransitionGroup enter='fadeIn' leave='fadeOut' className='app-container u-full-height'>
            {isInitialized ? <div className='u-full-height'>{children}</div> : <Spinner large />}
          </VelocityTransitionGroup>
        </SlideMenuContainer>
      ) : (
        <div className='app-container'>
          {authState?.isAuthenticated && !accountsLoaded && location.pathname !== '/select-accounts' && (
            <Spinner large />
          )}
          <div>{children}</div>
        </div>
      );
    return (
      <DocumentTitle title={import.meta.env.VITE_APP_NAME}>
        <>
          <div
            className={classnames('body-3 u-full-height d-sm-flx flx-dir-sm-c', {
              isAdminCart,
              isReturnStep,
              isStaticPage,
              // TODO: Convert all this nonsense above to use this instead..
              hideDefaultTopNavigation
            })}
            aria-hidden={modalIsVisible}
          >
            <div id='modal-root' />
            <OfflineBanner />
            <DownloadBanner />
            {body()}
            <Toast />
            {authState?.isAuthenticated && <Timer />}
          </div>
          <Modal />
        </>
      </DocumentTitle>
    );
  }
}

Root.propTypes = {
  ...rootPropTypes
};

Root.defaultProps = {
  userData: null,
  account: null,
  currentAllotments: null,
  futureAllotments: null,
  lastLocation: null,
  selectedDepartment: null,
  currentCartCrd: null,
  cartRecentlySubmitted: false,
  oktaAuth: null
};

const mapStateToProps = state => ({
  userData: getUserData(state),
  account: getUserAccount(state),
  accountDetails: accountDetails(state),
  accountsLoaded: getAllAccountsLoadedInfo(state),
  currentAllotments: getCurrentAllotments(state),
  futureAllotments: getFutureAllotments(state),
  hasLoginStarted: hasLoginStarted(state),
  isAdminCart: isAdminCart(state),
  isLoggedIn: isLoggedIn(state),
  isReturnStep: isReturnStep(state),
  selectedDepartment: getSelectedDepartment(state),
  isStaticPage: isStaticPage(state),
  modalIsVisible: visible(state),
  currentCartCrd: currentCartCrd(state),
  hideDefaultTopNavigation: hideDefaultTopNavigation(state),
  hasAuthCheckStarted: hasAuthCheckStarted(state)
});

export default withRouter(
  withLastLocation(
    connect(mapStateToProps, {
      closeNavMenu,
      getCart,
      getAccountDetails,
      getAccountDepartments,
      requestCurrentCartCrd,
      getFundamentalData,
      fetchGamedayAccount: gamedayAccountRequest,
      initializeUserAuth,
      requestAllAddresses,
      requestMinRules,
      selectShopDepartment,
      setAlwaysShowCart,
      setDeepLinkInfoLoading,
      setOrderDetails,
      setUserAccount,
      storeUserData,
      setUseCurrentContract
    })(withOktaAuth(Root))
  )
);
